import { FC } from 'react'
import { useSelector } from 'react-redux'
import { getOraclePrices } from '../../redux/modules/app'
import { calculateLoanAmount, getCollateralAsNumber } from '../../utils/helpers'
import { CssTextField } from '../OpenLoan/OpenLoan'

interface propsState {
  collateral: string
}

export const LoanAmountEstimate: FC<propsState> = (props) => {
  const oraclePrices = useSelector(getOraclePrices)

  return (
    <CssTextField
      variant="outlined"
      fullWidth={true}
      type={'text'}
      label="Est. Loan Amount"
      id="loan-amount"
      value={calculateLoanAmount(
        getCollateralAsNumber(props.collateral),
        oraclePrices.SOL_USD
      )}
    />
  )
}
